import { render, staticRenderFns } from "./Carroussel2.vue?vue&type=template&id=6395327b&scoped=true"
import script from "./Carroussel2.vue?vue&type=script&lang=js"
export * from "./Carroussel2.vue?vue&type=script&lang=js"
import style0 from "./Carroussel2.vue?vue&type=style&index=0&id=6395327b&prod&scoped=true&lang=css"
import style1 from "./Carroussel2.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6395327b",
  null
  
)

export default component.exports